import config from '../../../../application/config/config';
import { loadData } from '../Util/List/CustomList/loadData';
import CustomList from '../Util/List/CustomList/CustomList';
import CustomListContainer from '../Util/List/CustomList/CustomListContainer';
import { useState } from 'react';

const statusOptions = [{ label: 'Ativo', value: '1' }, { label: 'Inativo', value: '0' }];

function List() {
    const [values, setValues] = useState({ status: '1' });

    const pathFrontEnd = '/core/applicationsinstances/';

    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpoint: config.endpoints.backend + 'core/applicationsinstances/getall',
        endpointUpdate: config.endpoints.backend + 'core/applicationsinstances/save',
        endpointDelete: config.endpoints.backend + 'core/applicationsinstances/delete'
    };

    const handleChange = (form) => {
        const name = form['target']['name'];
        const value = form['target']['value'];

        setValues(prev => ({ ...prev, [name]: value }));
    };

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            {
                name: 'status',
                type: 'select',
                label: 'Status',
                handleChange,
                isClearable: true,
                options: statusOptions,
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            }
        ],
        values: { ...values },
    };

    const list = {
        labelTitle: 'Lista de Instalações',
        labelTitleButtonAdd: 'Nova instalação',
        fieldsShowOnDelete: ['instance_name'],
        showPrintButtons: false,
        canDelete: false,
        formFilters: filters,
        columns: [
            {
                name: 'instance_name',
                label: 'Instalação',
                width: '20%'
            },
            {
                name: 'status',
                label: 'Status',
                options: statusOptions,
                editable: true,
                type: "select",
                endpointSave: paths.endpointUpdate,
                width: '20%',
                minWidth: '120px'
            },
        ],
        ...paths,
    };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={list} />}
            />
        </div>
    );
}
export default List;
